// PR-ONBOARDING-SUCCESS-REF-PERSIST-1 — keep the request reference alive on the
// success page across a hard refresh. Router-state is wiped on reload, so we
// ALSO carry the id in the URL (?requestId=…) and mirror it in sessionStorage.
//
// SuccessPage resolves the id in priority order:
//   1. query param `requestId`
//   2. router state `submissionId`
//   3. sessionStorage `lastOnboardingRequestId`

const SUCCESS_PATH = '/registrazione-intermediario/success';
const SESSION_KEY = 'lastOnboardingRequestId';

/** Build the success-page path, embedding the request id as a query param. */
export function buildSuccessPath(requestId: string | null | undefined): string {
  return requestId
    ? `${SUCCESS_PATH}?requestId=${encodeURIComponent(requestId)}`
    : SUCCESS_PATH;
}

/** Mirror the request id in sessionStorage (best-effort; private mode safe). */
export function persistLastRequestId(requestId: string | null | undefined): void {
  if (!requestId) return;
  try {
    sessionStorage.setItem(SESSION_KEY, requestId);
  } catch {
    // sessionStorage unavailable (private mode / blocked) — non-fatal.
  }
}

/** Read the last request id mirrored in sessionStorage, or null. */
export function readLastRequestId(): string | null {
  try {
    const v = sessionStorage.getItem(SESSION_KEY);
    return v && v.length > 0 ? v : null;
  } catch {
    return null;
  }
}
